<div class="detail-container">
  <div class="container">
    <div class="header">
      <div
        class="icon-exit pt-3"
        *ngIf="data?.itemNo !== 0 && data?.itemNo !== 3 && data?.itemNo !== 5"
      >
        <img
          class="close"
          src="{{ RESOURCE_SERVER_URL }}/assets/images/Close.svg" alt="Close Icon"
          (click)="onClose()"
        />
      </div>
    </div>
  </div>
  <div class="body-dialog">
    <ng-container *ngIf="data?.itemNo == 0">
      <app-view-beneficiary></app-view-beneficiary>
    </ng-container>
    <ng-container *ngIf="data?.itemNo == 1">
      <app-bmi-and-questionaire></app-bmi-and-questionaire>
    </ng-container>
    <ng-container *ngIf="data?.itemNo == 2">
      <app-requirements></app-requirements>
    </ng-container>
    <ng-container *ngIf="data?.itemNo == 3">
      <app-loading-information></app-loading-information>
    </ng-container>
    <ng-container *ngIf="data?.itemNo == 4">
      <app-underwriting-comments></app-underwriting-comments>
    </ng-container>
    <ng-container *ngIf="data?.itemNo == 5">
      <app-policy-inquiry></app-policy-inquiry>
    </ng-container>
  </div>
</div>
